<template>
  <b-card>
    <div class="d-flex justify-content-between align-items-center mb-1">
      <div>
        <h4 class="mb-25">S3 health</h4>
        <p class="text-muted mb-0">
          Uploads a probe file, reads it back, then deletes it. The same check runs for the active storage disk.
        </p>
      </div>
      <b-button variant="primary" :disabled="loading" @click="run">
        {{ loading ? 'Checking…' : 'Run health check' }}
      </b-button>
    </div>

    <b-alert v-if="error" show variant="danger">{{ error }}</b-alert>

    <b-row v-if="checks.length">
      <b-col
        v-for="check in checks"
        :key="check.disk"
        md="6"
        class="mb-1"
      >
        <b-card class="mb-0 border">
          <div class="d-flex justify-content-between align-items-center mb-50">
            <h5 class="mb-0 text-uppercase">{{ check.disk }}</h5>
            <b-badge :variant="variant(check.status)">{{ check.status }}</b-badge>
          </div>
          <p class="mb-50">{{ check.message }}</p>
          <p v-if="check.latency_ms !== null" class="text-muted mb-50">
            Latency {{ check.latency_ms }} ms
          </p>
          <ul class="list-unstyled mb-0 text-muted">
            <li v-if="check.config && check.config.driver">Driver: {{ check.config.driver }}</li>
            <li v-if="check.config && check.config.bucket">Bucket: {{ check.config.bucket }}</li>
            <li v-if="check.config && check.config.region">Region: {{ check.config.region }}</li>
            <li v-if="check.config && check.config.key_set !== undefined">
              Key set: {{ check.config.key_set ? 'yes' : 'no' }}
            </li>
            <li v-if="check.config && check.config.secret_set !== undefined">
              Secret set: {{ check.config.secret_set ? 'yes' : 'no' }}
            </li>
          </ul>
        </b-card>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BAlert, BBadge, BButton, BCard, BCol, BRow,
} from 'bootstrap-vue'
import { adminPanelApi } from '@/services/adminPanelApi'

export default {
  components: {
    BAlert, BBadge, BButton, BCard, BCol, BRow,
  },
  data() {
    return {
      loading: false,
      error: '',
      checks: [],
    }
  },
  created() {
    this.run()
  },
  methods: {
    async run() {
      this.loading = true
      this.error = ''
      try {
        const res = await adminPanelApi.setupStorageHealth()
        this.checks = res.data?.data?.checks || []
      } catch (error) {
        this.error = error?.response?.data?.message || 'Storage health check failed.'
      } finally {
        this.loading = false
      }
    },
    variant(status) {
      if (status === 'ok') return 'success'
      if (status === 'not_configured') return 'secondary'
      return 'danger'
    },
  },
}
</script>
